import script from "./BalanceSheetColumnwiseTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BalanceSheetColumnwiseTable.vue?vue&type=script&setup=true&lang=js"

import "./BalanceSheetColumnwiseTable.vue?vue&type=style&index=0&id=a586efb4&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a586efb4"]])

export default __exports__